import AdminEditWorker from "./AdminEditWorker";

export default AdminEditWorker;
